import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=20d8d742"
import script from "./CustomerHeader.vue?vue&type=script&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d8d742')) {
      api.createRecord('20d8d742', component.options)
    } else {
      api.reload('20d8d742', component.options)
    }
    module.hot.accept("./CustomerHeader.vue?vue&type=template&id=20d8d742", function () {
      api.rerender('20d8d742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/CustomerHeader.vue"
export default component.exports